import React, { useState } from "react";
import ProfileTopNavBar from "./ProfileTopNavBar";
import {
  Collapse,
  Typography,
  Upload,
  notification,
  Switch,
  TimePicker,
} from "antd";
import { CheckCircleTwoTone, CloseOutlined } from "@ant-design/icons";
import { updateProfile } from "../../controllers/accounts/Account";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import { beforeUpload } from "../../controllers/common";

const { Panel } = Collapse;
const { Text } = Typography;

function StoreDetailsForm() {
  const location = useLocation();
  const [ADMININFO, setAdminInfo] = useState(location.state.ADMININFO || {});
  const [image, setImageList] = useState("");
  const navigate = useNavigate();
  const [errors, serError] = useState([]);

  /*********************************************************
   *  This function is use to handle success notification show
   *********************************************************/
  const handleSuccessMessg = () => {
    notification.open({
      message: "Success!",
      description: " Data Saved Successfully .",
      placement: "topRight",
      duration: 2,
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    });
  }; //End

  /*********************************************************
   *  This function is use to handle error notification show
   *********************************************************/
  const handleErrorMsg = (msg = "") => {
    notification.open({
      message: "Oops!",
      // description: error?.formError || msg,
      placement: "topRight",
      duration: 2,
      icon: <CloseOutlined style={{ color: "red" }} />,
    });
  }; //End

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      setAdminInfo((pre) => ({
        ...pre,
        [name]: value,
      }));
    } catch (error) {}
  };

  /*********************************************************
   *  This function is use to handle image object
   *********************************************************/
  const handleImageChnage = (e) => {
    setImageList(e.fileList[0].originFileObj);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let form = new FormData(e.target);
    // form.append("admin_image", image ? image : null);
    // console.log(form.get('admin_last_name'));
    form.append("editId", ADMININFO?._id);
    form.append("ipAddress", sessionStorage.getItem("IP_ADDRESS"));
    const isValidate = validateFormData(form);
    // console.log("form validation", isValidate)
    // console.log('err',errors)
    if (isValidate) {
      const res = await updateProfile(form);
      console.log("Admin updateProfile", res);
      if (res.status === true) {
        setImageList("");
        handleSuccessMessg();
        // handleCancel();
        navigate("/profile");
      } else {
        // StorageError((pre) => ({
        //   ...pre,
        //   formError: res?.message
        // }))
        // handleErrorMsg();
      }
      // setIsLoading(false);
    } else {
      // setIsLoading(false);
      handleErrorMsg("Please fill required fields.");
    }
  }; //End

  /*********************************************************
   *  This function is use to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    if (
      formData.get("admin_first_name") === "undefined" ||
      formData.get("admin_first_name") === null ||
      formData.get("admin_first_name").trim() === ""
    ) {
      serError((preError) => ({
        ...preError,
        admin_first_name: "Admin first name is required",
      }));
      return false;
    } else if (
      formData.get("admin_last_name") === "undefined" ||
      formData.get("admin_last_name") === null ||
      formData.get("admin_last_name").trim() === ""
    ) {
      serError((preError) => ({
        ...preError,
        admin_last_name: "Admin last name is required",
      }));
      return false;
    } else if (
      formData.get("admin_phone") === "undefined" ||
      formData.get("admin_phone") === null ||
      formData.get("admin_phone").trim() === ""
    ) {
      serError((preError) => ({
        ...preError,
        admin_phone: "Phone is required",
      }));
      return false;
    } else if (
      formData.get("admin_email") === "undefined" ||
      formData.get("admin_email") === null ||
      formData.get("admin_email").trim() === ""
    ) {
      serError((preError) => ({
        ...preError,
        admin_email: "Email is required",
      }));
      return false;
    } else {
      return true;
    }
  };
  // console.log("ADMININFO", ADMININFO);
  return (
    <div>
      <ProfileTopNavBar></ProfileTopNavBar>
      <div className="container-fluid">
        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form onSubmit={handleSubmit}>
                <div class="py-1 text-start">
                  <span className="profile_store_details_heading">
                    Profile Details{" "}
                  </span>
                </div>
                <div className="store_details_all_form_section">
                  <div class="form-row">
                    <div className="store_details_form_owner_name">
                      <div class="col">
                        <label
                          for="firstName"
                          className="profile_label_store_name"
                        >
                          First Name
                        </label>
                        <input
                          className="form-control all_input_tag_tagenter_product_"
                          type="text"
                          name="admin_first_name"
                          placeholder="First Name"
                          id="storeName"
                          value={ADMININFO?.admin_first_name}
                          onChange={handleChange}
                        />
                        {errors?.admin_first_name ? (
                          <p style={{ color: "red" }}>
                            {errors.admin_first_name}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="col">
                        <label
                          for="ownerName"
                          className="profile_label_store_name"
                        >
                          Last Name
                        </label>
                        <input
                          className="form-control all_input_tag_tagenter_product_"
                          type="text"
                          name="admin_last_name"
                          id="lastName"
                          placeholder="Last Name"
                          value={ADMININFO?.admin_last_name}
                          onChange={handleChange}
                        />
                        {errors?.admin_last_name ? (
                          <p style={{ color: "red" }}>
                            {errors.admin_last_name}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="col">
                        <label
                          for="phoneNo"
                          className="profile_label_store_name"
                        >
                          Phone No.
                        </label>
                        <input
                          className="form-control all_input_tag_tagenter_product_"
                          type="number"
                          name="admin_phone"
                          placeholder="+91"
                          id="phoneNo"
                          value={ADMININFO?.admin_phone}
                          onChange={handleChange}
                          maxLength={10}
                        />
                        {errors?.admin_phone ? (
                          <p style={{ color: "red" }}>{errors.admin_phone}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="form-row col-12">
                    <div className="store_details_form_owner_name">
                      <div class="col-4">
                        <label
                          for="emailAddress"
                          className="profile_label_store_name"
                        >
                          Email Address*
                        </label>
                        <input
                          type="email"
                          class="form-control all_input_tag_tagenter_product_"
                          name="admin_email"
                          placeholder="Email"
                          id="emailAddress"
                          value={ADMININFO?.admin_email}
                          onChange={handleChange}
                        />
                        {errors?.admin_email ? (
                          <p style={{ color: "red" }}>{errors.admin_email}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="store_details_form_submit_button">
                  <button
                    type="submit"
                    class="btn btn-dark store_details_form_btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreDetailsForm;
